module.exports = new __parcel__URL__("effects.fbcc1da6.ogg").toString();